





























import { Component, Prop, Emit, Vue } from 'vue-property-decorator';

@Component
export default class Seconds extends Vue {
	@Prop({ default: [] }) public accounts!: any[];

} 
